import { _nwpProdList } from '../../../static/api/index'
import moment from 'moment';
export default {
  name: "App",
  props: {
    parentMenuItem: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      moment,
      areaValue: "",
      current: localStorage.getItem("image-time") || 0,
      timeList: [],
      areaOptions: [],
      prodImgList: [],
      // imgLen: 2,
      // imgView: [],
      // urlType: '',
      // global_NDVI: window.fyEarth.global_NDVI,
      // iframeUrl: window.fyEarth.iframeUrl,
      // 预报数据
      forecastData: [],
      forecastCurrent: 0,
      // 时次下拉（选择时次信息定位预报信息）
      nwpOptions: [],
      nwpOptionValue: '',
      // 查看大图
      centerDialogVisible: false,
      dialogImgData: {},
      // 控制是否开启鼠标移动
      isMousedown: false,
      // 开启滚轮缩放
      isHover: false,
      // 移动的位置
      moveStart: {},
      // 缩放的坐标
      translate: {x: 0, y: 0},
      // 缩放的大小
      scale: 1,
      // 缩放的最大值和最小值
      scaleZoom: {
        max: 5,
        min: 0.2
      },
      forecastList: []
    };
  },
  watch:{
    parentMenuItem: {
      handler(newValue, oldValue){
        console.log('newValue', newValue)
        // 有区域时走区域选择逻辑，无区域时直接获取时次列表
        // if(newValue.region && newValue.region.length){
        //   const area = localStorage.getItem('area') || this.parentMenuItem.region[0].enName
        //   this.changeOption(area)
        // } else {
        //   this.getProdList()
        // }
        if(Object.keys(newValue).length > 0 && newValue.region && newValue.region.length > 0){
          // const area = localStorage.getItem('area') || [this.parentMenuItem.region[0].enName]
          // let getArea = localStorage.getItem('area')
          // 判断区域是否存在
          // let item = newValue.region.find(item => {
          //   return item.enName == getArea
          // })
          // let area = ''
          // if (item == undefined) {
          //   area = this.parentMenuItem.region[0].enName
          // } else {
          //   area = item.enName
          // }
          let area = this.parentMenuItem.region[0].enName
          this.changeOption([area])
        }
        if(Object.keys(newValue).length > 0 && newValue.region.length == 0) {
          this.getProdList()
        }
      },
      // immediate: true
    }
  },
  created() {
    console.log("parentMenuItem", this.parentMenuItem);
  },
  mounted(){
    window.addEventListener('mousewheel', this.handleNwpScroll, false)
  },
  methods: {
    // 选择区域
    changeOption(value) {
      this.areaValue = value
      localStorage.setItem('area', value)
      this.areaOptions = this.region_array(this.parentMenuItem.region)
      this.getProdList()
    },
    // 获取产品数据
    getProdList(){
      const prodName = localStorage.getItem('prodName')
      let dataType = localStorage.getItem('dataType')
      let params = {}
      if(dataType !== 'undefined'){
        params = {
          abbr: prodName,
          region: this.$store.state.regionLength == 0 ? '' : this.areaValue,
          dataType: dataType
        }
      } else {
        params = {
          abbr: prodName,
          region: this.$store.state.regionLength == 0 ? '' : this.areaValue
        }
      }
      // let params = {
      //   abbr: prodName,
      //   region: this.$store.state.regionLength == 0 ? '' : this.areaValue
      // }
      this.timeList = []
      this.forecastData = []
      _nwpProdList(this.$store.state.logo, params).then((result)=>{
        let _data = result.data
        if(_data.length){
          // 上面列表
          this.timeList = _data
          // 中间时次下拉列表
          this.nwpOptions = _data
          // 预报信息
          // _data.forEach((val)=>{
          //   this.forecastData.push(val.timeArr[0])
          // })
          this.changeTime(this.timeList[0], 0)
        }
      })
    },
    // 改造区域数据结构
    region_array(dataParams) {
      var _this = this;
      var data = [];
      dataParams.forEach(function (v, i) {
        var city_one = { value: v.enName, label: v.enName};
        if (v.children.length) {
          city_one.children = _this.region_array(v.children);
        } 
        // else {
        //     city_one.children = [];
        // }
        data.push(city_one);
      });
      
      return data;
    },

    /*
      选择时次, 获取预报信息
      params:
        prod 时次信息
        index 时次信息索引
    */ 
    changeTime(prod, index) {
      this.forecastList = []
      // localStorage.setItem("image-time", index);
      this.current = index;
      this.forecastData = prod.timeArr
      // 点击上面列表，对应筛选下方列表，并选中，右侧展示对应图片信息
      this.siteForecastInfo(prod.timeArr, prod.strETime)
      // 选择Forecast下拉筛选信息
      // this.changeForecast(prod.timeArr, 0)
    },

    /*
      选择时次信息， 筛选并定位预报信息到列表顶部，并展示对应产品成果
      params
        value 时次时间
    */
    changeNwpOption(value){
      this.forecastFilter(this.forecastData, value)
    },
    forecastFilter(_forecastData, _strBTime) {
      _forecastData.forEach((val, index)=>{
        this.forecastCurrent = -1
        if(val.strBTime == _strBTime){
          this.forecastCurrent = index
          this.$refs.forecastList.scrollTo({
            top: 48 * index,
            behavior: "smooth", // 平滑
            // block: "start",
          })
        }
      })
    },
    /*
      选择预报信息
      params：
        item 当前预报时次信息
        index 当前预报信息索引
    */
    changeForecast(item, index){
      console.log('999', )
     
      let a = [{
        "resolution": "0.064",
        "width": "853",
        "height": "960",
        "dataType": "POAI",
        "MaxLat": 56,
        "MinLat": 28,
        "MaxLon": 90,
        "MinLon": 45,
        "forecast": true,
        "_id": "645cb44012926829cbc22a45",
        "strSatID": "FY4A",
        "strInstrument": "AGRI",
        "abbr": "AMVI",
        "strBTime": "20230510000000",
        "strETime": "20230510060000",
        "region": "WestAsia",
        "oriImgFileName": "http://fyearth.nsmc.org.cn/service/static/IMAGES/FY4A/AGRI/AMVI/POAI/20230510/FY4A_AGRI_L2_AMVI_C012-CMAGFS-WIND-500hPa_GLL_20230510000000_20230510060000_064KM_POAI_X_WesternAsia_X.jpg",
        "thematicFileName": "http://fyearth.nsmc.org.cn/service/static/IMAGES/FY4A/AGRI/AMVI/POAI/20230510/FY4A_AGRI_L2_AMVI_C012-CMAGFS-WIND-500hPa_GLL_20230510000000_20230510060000_064KM_POAI_X_WesternAsia_THEM.jpg",
        "smallImgFileName": "http://fyearth.nsmc.org.cn/service/static/IMAGES/FY4A/AGRI/AMVI/POAI/20230510/FY4A_AGRI_L2_AMVI_C012-CMAGFS-WIND-500hPa_GLL_20230510000000_20230510060000_064KM_POAI_X_WesternAsia_SMALL.jpg",
        "subProductName": "AMVI-C012-CMAGFS-WIND-500hPa",
        "ProjType": "GLL",
        "OrbitType": "X",
        "modified": "2023-05-11 10:31:35",
        "__v": 0,
        "hour": 6,
        "url": "http://fyearth.nsmc.org.cn/service/static/IMAGES/FY4A/AGRI/AMVI/POAI/20230510/FY4A_AGRI_L2_AMVI_C012-CMAGFS-WIND-500hPa_GLL_20230510000000_20230510060000_064KM_POAI_X_WesternAsia_SMALL.jpg"
      }]
      let _data = item.list
      this.prodImgList = _data
    },

    /*
      根据选择的时次信息，定位预报信息
      forecastData 全部预报信息
    */ 
    siteForecastInfo(_forecastData, _OneStrETime){
      _forecastData.forEach((val, index)=>{
        this.forecastCurrent = -1
        if(val.strETime == _OneStrETime){
          this.forecastCurrent = index
          this.prodImgList = val.list
          this.$refs.forecastList.scrollTo({
            top: 48 * index,
            behavior: "smooth", // 平滑
            // block: "start",
          })
        }
      })
    },
    // 查看更多
    moreData() {
      document.getElementById("historyTitle").style.display = "block";
      document.getElementById("header").style.display = "none";
      document.getElementById("sliderBox").style.display = "none";
      document.getElementById("more").style.display = "none";
      document.getElementById("mainBox").style.width = "calc(100vw - 20px)";
      document.getElementById("mainBox").style.height = "calc(100vh - 48px)";
      document.getElementById("main").style.height = "100vh";
    },
    // 查看大图
    // 没有时次列表时,查看大图
    bigImg(imgData){
      this.centerDialogVisible = true
      this.dialogImgData = imgData
    },
    close(){
      this.centerDialogVisible = false
      this.isHover = false
    },
    // 鼠标按下事件 拖动图片文件
    mousedownDragImg(e){
      e.preventDefault()
      
      // 获取元素
      var zoomBox = document.querySelector('.dragElement')
      var imgInfo = this.$refs.dragElement
      var x = e.pageX - imgInfo.offsetLeft
      var y = e.pageY - imgInfo.offsetTop
      imgInfo.style.margin = 'auto'

      // 添加鼠标移动事件
      zoomBox.addEventListener('mousemove', move)
    
      function move(e) {
        imgInfo.style.left = e.pageX - x + 'px'
        imgInfo.style.top = e.pageY - y + 'px'
      }
      // 添加鼠标抬起事件，鼠标抬起，将事件移除
      imgInfo.addEventListener('mouseup', function() {
        zoomBox.removeEventListener('mousemove', move)
      })
      // 鼠标离开元素，把事件移除
      zoomBox.addEventListener('mouseout', function() {
        zoomBox.removeEventListener('mousemove', move)
      })
      // 鼠标抬起事件 移除事件
      zoomBox.addEventListener('mouseup', function() {
        zoomBox.removeEventListener('mousemove', move)
      })
    },
    // 鼠标滚轮事件，开启缩放
    handleNwpScroll(e) {
      if(this.isHover) {
        let speed = e.wheelDelta / 120
        if(e.wheelDelta > 0 && this.scale < this.scaleZoom.max) {
          this.scale += 0.2 * speed
          this.$refs.dragElement.style.transform = `scale(${this.scale}) translate(${this.translate.x}px, ${this.translate.y}px)`
        }else if(e.wheelDelta < 0 && this.scale > this.scaleZoom.min){
          this.scale += 0.2 * speed
          this.$refs.dragElement.style.transform = `scale(${this.scale}) translate(${this.translate.x}px, ${this.translate.y}px)`
        }
      }
    },
  },
};